import axios from "axios";

const axiosInstance = axios.create({
  baseURL:process.env.REACT_APP_BASE_URL
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token && config.useAuth) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 403) {
      // redirect to login
      window.location.href = "/login";
    }
    console.log("error",error)
    return Promise.reject(error);
  }
);

export default axiosInstance;
